// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { LinkTag } from '@crehana/ui';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const WrapperUpload = styled.div<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    width: 100%;
    padding: 26px 34px 35px;
    margin-bottom: 24px;
    background-color: ${isDark ? theme.colors.base.main : theme.colors.white};
    box-shadow: ${
      isDark
        ? 'none'
        : '0px 0px 16px rgba(195, 203, 214, 0.16), 0px 1px 4px rgba(195, 203, 214, 0.16)'
    };
    border-radius: 16px;
    ${theme.breakpoints.down('sm')} {
      padding: 16px;
    }
  `,
);

export const AttributeWrapper = styled.label(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 16px;

    min-height: 180px;
    background-color: transparent;
    padding: 0 16px;
    text-align: center;
    background-color: ${theme.colors.gray.lighter};
    border-radius: 16px;
  `,
);

export const FileHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Divider = styled.div<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    border-bottom: 1px solid
      ${isDark ? theme.colors.gray['dark-24'] : theme.colors.gray.light};
    margin: 20px -34px 28px -34px;

    ${theme.breakpoints.down('sm')} {
      margin: 20px -16px 28px -16px;
    }
  `,
);

export const ChipTag = styled(LinkTag)`
  border-radius: 30px;
  padding: 8px 12px;
  height: auto;
`;

export const Popper = styled.div<{ isDark?: boolean }>(
  ({ theme, isDark }) => css`
    position: absolute;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px 17px;
    max-width: 180px;
    max-height: 180px;
    overflow: auto;
    background-color: ${
      isDark ? theme.colors.base['light-dark-mode'] : theme.colors.white
    };
    box-shadow: ${
      isDark
        ? 'none'
        : '0px 0px 16px rgba(195, 203, 214, 0.18), 0px 4px 8px rgba(195, 203, 214, 0.18)'
    };
    border-radius: 12px;
  `,
);
